export const INCOMPLETE = '';
export const VALIDATION_MSG_DUPLICATE_DESTINATION =
  'Destination field can only be mapped once';
export const VALIDATION_MSG_INCOMPATIBLE_TYPE =
  'Source and destination types are incompatible. This could result in data loss during conversion';

export const typeMapping: {
  [destinationType: string]: string[];
} = {
  string: [
    'string',
    'integer',
    'float',
    'decimal',
    'boolean',
    'timestamp',
    'date',
    'number',
    'datetime'
  ],
  integer: ['integer', 'long', 'int'],
  number: ['integer', 'number', 'long'],
  float: ['float'],
  decimal: ['float', 'double', 'decimal'],
  long: ['long', 'integer'],
  double: ['double', 'float'],
  boolean: ['boolean', 'bool'],
  date: ['timestamp', 'date'],
  timestamp: ['timestamp', 'date'],
};

export enum ValidationType {
  ERROR = 'error',
  WARNING = 'warning',
}

export enum MappingTarget {
  SOURCE = 'source',
  DESTINATION = 'destination',
}

export interface MappingValidation {
  name: string;
  target: MappingTarget;
  type: ValidationType;
  message: string;
}

export interface SrcDestPair {
  source: string;
  destination: string;
  disabled?: boolean;
  validation?: MappingValidation;
}

export const getValidationObject = (
  mapping: SrcDestPair,
  target: MappingTarget
): MappingValidation | undefined => {
  return mapping.validation?.target === target ? mapping.validation : undefined;
};

export const getValidationClassName = (
  mapping: SrcDestPair,
  target: MappingTarget,
  styles: any
) => {
  const validation = getValidationObject(mapping, target);
  if (!validation) {
    return '';
  }
  switch (validation.type) {
    case ValidationType.ERROR:
      return styles.dropdown_error_state;
    case ValidationType.WARNING:
      return styles.dropdown_warning_state;
    default:
      return '';
  }
};
